module.exports = __webpack_public_path__ + "static/Foster_FINAL.ad3c5122.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/img/stories/jessica-foster/Foster_FINAL.mp4
// module id = 365
// module chunks = 118551011512839